/**
 * Labstep
 *
 * @module containers/File/Download
 * @desc Download a file
 */

import { downloadFile } from 'labstep-web/state/actions/file';
import { selectDownloadFileStatus } from 'labstep-web/state/selectors/file';
import { connect } from 'react-redux';
import type { IFileDownloadContainerProps, OwnProps } from './types';

export type FileDownloadContainerChildrenProps = ReturnType<
  typeof mapStateToProps
> &
  typeof mapDispatchToProps;

const DownloadContainer = ({
  children,
  ...rest
}: FileDownloadContainerChildrenProps & {
  children: (
    childrenProps: Omit<
      FileDownloadContainerChildrenProps,
      'children'
    >,
  ) => JSX.Element | null;
}) => children(rest);

const mapStateToProps = (state: any, ownProps: OwnProps) => ({
  status: selectDownloadFileStatus(state, ownProps.file.id),
});

const mapDispatchToProps = {
  downloadFile,
};

export const FileDownloadContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DownloadContainer);
